import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import { SURGERY_TYPE } from '../../../../../constants/dropdown';

const TABLE_HEADER = [
  {
    header: 'Doctor Name',
    accessor: 'name'
  }
];

export const AddResourcesDetailsForm = ({ onClose, chargeType = 'opd_charges', doctorID, onAdd, doctorDropdown,editData,isEditMode}) => {
    
  const [input, setInput] = useState('');
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        doctor: Yup.string().required('Please select Service')
      })
    ),
    mode: 'all'
  });
  const { reset } = methods

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const doctorId = doctorDropdown.find(({ _id }) => _id === formValues.doctor)?._id || '';
    const Doctor = "Doctor"
    const transformedValues = {
      ...formValues,
      doctor: doctorId ,
      type : Doctor
    };
    console.log("HELLLO TRANSFORMED VALUES", transformedValues)
    onAdd(transformedValues);
  };


  const handleServiceSelection = (row) => {
    setValue('doctor', row._id);
  };

//   useEffect(() => {
//     const filtered = mergeDropdowns().filter(
//       (item) =>
//         item.name.toLowerCase().includes(input.toLowerCase())
//     );
//     setFilteredServiceList(filtered);
//   }, [input, mergeDropdowns]);

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };


  useEffect(()=>{
    console.log("DOCTORSSSSS",doctorDropdown)
  },[doctorDropdown])

  useEffect(() => {
    if (isEditMode && editData) {
      reset({
        doctor: editData.doctor,
      });
    } else {
      reset(); // Reset the form when not editing
    }
  }, [isEditMode, editData, reset]);
  
  
  useEffect(() => {
    if (!isEditMode) {
      reset();
    }
  }, [isEditMode, reset]);

  
  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Doctor Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
        <MuiTextField
          sx={{ width: '100%', padding: 0, font: "32px" }}
          label="Search Doctor"
          variant="outlined"
          value={input}
          onChange={handleInputChange}
          InputProps={{
            style: {
              fontSize: '12px',
              fontWeight: 600
            },
          }}
        />
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto', }}
              size="small"
              sx={{ fontSize: "32px" }}
              data={doctorDropdown || []}
              columns={TABLE_HEADER}
              onRowClick={handleServiceSelection}

            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: .2, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor</Typography>
                <SelectTag
                  formControlSX={{ flex: 0.8 }}
                  menus={doctorDropdown.map((data) => ({ ...data, name: data.name }))}
                  name="doctor"
                  placeholder="Select Region"
                />
              </Stack> 
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit"   >
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
